module.exports = `${require.publicPath}sby-logo-dark.c1fec1e5.webp`;